import styled, { css } from 'styled-components';
import { rem } from 'styles';

export const SignupContainer = styled.div(
	({ theme: { spacings } }) =>
		css`
			padding-top: 0;
			max-width: ${rem(1000)};
			margin: ${spacings[20]} auto ${spacings[128]};
		`
);
